"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetIcon = void 0;
const react_1 = __importDefault(require("react"));
const SVGIcon_1 = require("../SVGIcon");
const AssetIcon = props => (react_1.default.createElement(SVGIcon_1.SVGIcon, Object.assign({}, props, { viewBox: "0 0 100 100" }),
    react_1.default.createElement("g", null,
        react_1.default.createElement("path", { d: "M89.368,24.773L54.775,9.947L10.604,24.672L0,51.18l10.065,4.314v19.52l35.09,15.039l44.709-14.904V54.732L100,51.354   L89.368,24.773z M57.033,18.442L80.93,28.685L57.033,36.65V18.442z M8.932,47.481l5.922-14.807l24.317,10.422L33.25,57.902   L8.932,47.481z M42.898,81.558L16.984,70.45V56.058l18.847,8.077l7.067-17.668V81.558z M18.79,29.235l33.531-11.177v20.163   l-7.067,2.356L18.79,29.235z M82.947,70.162L47.61,81.941V46.466l7.068,17.668l28.27-9.423V70.162z M57.401,58.262l-5.917-14.795   l33.45-11.151l5.917,14.795L57.401,58.262z" }))));
exports.AssetIcon = AssetIcon;
exports.default = exports.AssetIcon;
